import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormControl } from 'react-bootstrap';
import cx from 'classnames';

import Link from '../../Link';
import CustomPagination from '../../CustomPagination';
import Loader from '../../../components/Common/Loader';

import history from '../../../history';
import updateSubCategoryStatus from '../../../actions/siteadmin/SubCategory/updateSubCategoryStatus';
import deleteSubCategory from '../../../actions/siteadmin/SubCategory/deleteSubCategory';
import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { demoRestriction } from '../../../actions/demoRestriction';
import { api, subCategoryUploadDir } from '../../../config';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './SubCategoryList.css';
import st from './SubCategoryStudio.css';

class SubCategoryList extends React.Component {
  static propTypes = {
    subCategoryDetails: PropTypes.object,
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchList: '',
      statusFilter: 'all'
    }
  }

  handleClick = () => {
    history.push('/add')
  }

  imgSrc = (image) => image ? api?.apiEndpoint + subCategoryUploadDir + 'medium_' + image : null;

  handleKeywordSearch = debounce((searchList) => {
    const { subCategoryDetails: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchList: searchList
    }
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);;
  });

  handleDelete = async (id, currentPage) => {
    const { deleteSubCategory, subCategoryDetails: { refetch, getAllSubCategory }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({ restrictType: 'subCategory', restrictValue: id });
    if (isRestrict) return;
    currentPage = await getCurrentPage({ results: getAllSubCategory?.results, page: currentPage });
    let variables = { currentPage }
    const response = await deleteSubCategory(id, currentPage);
    if (response?.status == 200) {
      this.setState({ currentPage });
      refetch(variables)
    }
  }

  paginationData = (currentPage) => {
    const { subCategoryDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  handleStatus = async (id, currentPage, fieldName, e) => {
    const { updateSubCategoryStatus, subCategoryDetails: { refetch }, demoRestriction } = this.props;
    let value = e.target.value;
    const isRestrict = await demoRestriction({ restrictType: 'subCategory', restrictValue: id });
    if (isRestrict) return;
    await updateSubCategoryStatus(id, currentPage, fieldName, value);
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  render() {
    const { subCategoryDetails, subCategoryDetails: { getAllSubCategory, loading } } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, statusFilter } = this.state;

    const allItems = getAllSubCategory?.results || [];
    const items = statusFilter === 'all' ? allItems : allItems.filter((it) => it.status === statusFilter);

    return (
      <div className={'whiteDropdown'}>
        <div className={st.toolbar}>
          <div className={st.filters}>
            <div className={cx(st.searchInput, 'searchInputRTL')}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
            </div>
            <select className={cx(bt.selectInput, st.filterSelect)} value={statusFilter} onChange={(e) => this.setState({ statusFilter: e.target.value })}>
              <option value="all">All statuses</option>
              <option value="active">{formatMessage(messages.active)}</option>
              <option value="inactive">{formatMessage(messages.inactive)}</option>
            </select>
          </div>
          <Link to={"/siteadmin/sub-category/add"} className={cx(bt.btnPrimary, bt.displayInlineBlock)} >{formatMessage(messages.addSubCategory)}</Link>
        </div>

        {loading && <Loader type="circle" />}

        {!loading && items.length === 0 && (
          <div className={st.empty}><FormattedMessage {...messages.noResult} /></div>
        )}

        {!loading && items.length > 0 && (
          <ul className={st.list}>
            {items.map((item) => {
              const thumb = this.imgSrc(item.image);
              return (
                <li key={item.id} className={st.row}>
                  {thumb
                    ? <img className={st.thumb} src={thumb} alt="" />
                    : <span className={st.thumbPlaceholder}>{(item.name || '?').charAt(0)}</span>}

                  <div className={st.nameCol}>
                    <span className={st.name}>{item.name}</span>
                    <span className={st.meta}>#{item.id} · {moment(parseInt(item.createdAt)).format('DD-MM-YYYY')}</span>
                  </div>

                  <span className={st.catBadge}>{item.categoryName}</span>

                  <select
                    value={item.status}
                    onChange={(e) => this.handleStatus(item.id, currentPage, 'status', e)}
                    className={cx(bt.selectInput, st.statusSelect, item.status === 'active' ? st.statusActive : st.statusInactive)}
                  >
                    <option value="active">{formatMessage(messages.active)}</option>
                    <option value="inactive">{formatMessage(messages.inactive)}</option>
                  </select>

                  <div className={st.actions}>
                    <Link to={'/siteadmin/sub-category/edit/' + item.id} className={st.actionLink} title={formatMessage(messages.editAction)}>
                      <CommonAdminEditIcon className={st.icon} />
                    </Link>
                    <button type="button" className={st.actionBtn} onClick={() => this.handleDelete(item.id, currentPage)} title={formatMessage(messages.deleteAction)}>
                      <CommonAdminTrashIcon className={st.icon} />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        {
          subCategoryDetails?.getAllSubCategory?.results && subCategoryDetails?.getAllSubCategory?.results?.length > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={subCategoryDetails?.getAllSubCategory?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.subCategories)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapDispatch = {
  updateSubCategoryStatus,
  deleteSubCategory,
  demoRestriction
};
const mapState = (state) => ({});

export default injectIntl(compose(
  withStyles(bt, s, st),
  connect(mapState, mapDispatch)
)(SubCategoryList))
